<template>
  <div>
    <div v-if="f_field.headline" class="mt-0 pt-0 mb-3">
      <v-flex
        style="background-color: #292929; color: #ddd"
        class="px-3 py-2 elevation-0 xs12"
      >
        <h3 class="font-weight-bold body-2 xs12 flex">
          {{ f_field.title }}
        </h3>
        <!-- <v-divider color='black'></v-divider> -->
      </v-flex>
    </div>

    <div v-else-if="f_field.subheadline" class="mt-2 mb-1">
      <v-flex style="" class="px-3 pb-0 xs12">
        <h3 class="xs12 flex">
          {{ f_field.title }}
          <!-- <v-menu offset-y class="right mb-1" v-if="!f_field.no_dynamic">
            <v-btn slot="activator" color="grey lighten-2" small icon class="mt-0 mb-0">
              <v-icon small color="grey lighten-5" >add</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in dynamic_field_list" :key="item.name" @click="add_field(item)">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu> -->
        </h3>
        <!-- <v-divider color='black'></v-divider> -->
      </v-flex>
    </div>

    <!-- <div v-if="f_field.component" class="mt-2 mb-2 mx-0"> -->
    <!-- <v-flex style="background-color:#fafafa;" class="px-3 py-2 elevation-1 xs12">
        <h3 class="subtitle xs12 flex">{{f_field.title}}  ({{count}})
            <v-btn @click="showUpload=!showUpload" color="grey lighten-5" small icon class="right mt-0 mb-0">
              <v-icon v-if="!showUpload" small>expand_more</v-icon>
              <v-icon v-if="showUpload" small dark>expand_less</v-icon>
            </v-btn>
        </h3> -->
    <!-- <component :is="f_field.component" :uploadCategory="f_field.title" :artist="f_artist" :name="f_field.name" :field="f_field" :film="film"></component> -->
    <!-- </v-flex> -->
    <!-- </div> -->

    <div v-else>
      <v-flex v-if="field_type == 'text-short'" px-3>
        <v-flex>
          <label>{{ label }}</label>

          <!-- v-model="f_field.model_string" -->
          <!-- :value="f_field.value_string" -->
          <v-text-field
            class=""
            :readonly="!isEditing"
            :name="f_field.name"
            :ref="f_field.name"
            :value="f_artist[f_field.name] ? f_artist[f_field.name] : ''"
            :hint="hint"
            hide-details
            :suffix="f_field.suffix"
            @input.native="$emit('input', $event.target.value)"
            :append-outer-icon="isEditing ? 'save' : 'edit'"
            @click:append-outer="saveOrEdit"
          ></v-text-field>
          <!-- @keyup="check_an($event.target.value)" -->
          <label style="color: #999">{{ f_field.title }}</label>
          <div v-if="an_exists">This accession number already exists!</div>
          <div v-if="saved" class="ml-3">Value was saved!</div>
          <div v-if="cannotSave" class="ml-3">
            Value already exists! Cannot save!
          </div>
          <!-- <v-btn v-if="f_field.dynamic" class="ml-3">
            <v-icon>remove</v-icon>
          </v-btn> -->
        </v-flex>
      </v-flex>

      <v-flex v-if="field_type == 'currency'" px-3 xs12 sm6 md4 d-flex>
        <v-flex xs12 sm6>
          <label>{{ label }}</label>
          <v-text-field
            class=""
            :readonly="!isEditing"
            :name="f_field.name"
            :ref="f_field.name"
            :value="`${f_artist[f_field.name]}`"
            :hint="`${f_field.title}`"
            persistent-hint
            :suffix="f_field.suffix"
            @input.native="$emit('input', $event.target.value)"
            :append-outer-icon="isEditing ? 'save' : 'edit'"
            @click:append-outer="saveOrEdit"
          ></v-text-field>
          <!-- @keyup="check_an($event.target.value)" -->
        </v-flex>

        <v-flex xs12 sm6>
          <v-select
            name="f_field.name+'_currency'"
            :items="constants.CURRENCIES"
            label=""
            :append-outer-icon="isEditing ? 'save' : 'edit'"
            :ref="f_field.name"
            :value="f_artist[`${f_field.name}_currency`]"
            hint="Currency"
            persistent-hint
            @click:append-outer="saveOrEdit"
            class="ml-0"
          ></v-select>
          <div v-if="an_exists">This accession number already exists!</div>
          <div v-if="saved" class="ml-3">Value was saved!</div>
          <div v-if="cannotSave" class="ml-3">
            Value already exists! Cannot save!
          </div>
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'text-long'" class="my-0 py-0 px-3">
        <v-textarea
          class="my-0"
          auto-grow
          :readonly="!isEditing"
          :name="f_field.name"
          :ref="f_field.name"
          rows="1"
          hide-details
          :value="f_artist[f_field.name] ? f_artist[f_field.name] : ''"
          :hint="`${f_field.title} - ${f_field.hint ? f_field.hint : ''}`"
          persistent-hint
          :append-outer-icon="isEditing ? 'save' : 'edit'"
          @click:append-outer="saveOrEdit"
          @input.native="$emit('input', $event.target.value)"
        ></v-textarea>
        <label style="color: #999">{{ f_field.title }}</label>
        <div v-if="an_exists">This accession number already exists!</div>
        <div v-if="saved" class="ml-3">Value was saved!</div>
        <div v-if="cannotSave" class="ml-3">
          Value already exists! Cannot save!
        </div>
        <!-- :label="f_field.title" -->
      </v-flex>

      <v-flex
        xs12
        md12
        v-else-if="this.field_type == 'date'"
        :class="`${f_field.class} mt-3 py-0 px-3`"
      >
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="32"
          :nudge-top="18"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="select_value"
            :label="f_field.title"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="select_value"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
        <!-- <v-flex xs4>
            <v-menu
              v-model="menu2" :return-value.sync="f_field.name" ref="menu2"
              :close-on-content-click="true" :nudge-right="40" lazy landscape transition="scale-transition" offset-y full-width min-width="290px"
            >
              <v-text-field
                v-model="f_field.name"
                slot="activator" label="f_field.name" prepend-icon="event" readonly
              ></v-text-field>
              <v-date-picker persistent
                v-model="f_field.name" @input="$refs.menu2.save(f_field.name)">
              </v-date-picker>

            </v-menu>             -->
        <!-- <v-text-field solo
              v-model="model"
              type="number"
              mask="####"
              max="2019"
              min="1900"
              :name="f_field.name"
              :ref="f_field.name"
              :value="`${f_artist[f_field.name]}`"
              label="Year"
              placeholder="Year"
              hint="Year"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field> -->
        <!-- </v-flex> -->
        <!-- <v-flex xs4>
            <v-text-field solo
              type="number"
              mask="##" 
              max="12"
              :name="f_field.name"
              :ref="f_field.name"
              :value="`${f_artist[f_field.name]}`"
              label="Month"
              placeholder="Month"
              hint="Month"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field solo
              type="number"
              mask="##" 
              max="31"
              :name="name"
              :value="`${f_artist[f_field.name]}`"
              label="Day"
              placeholder="Day"
              hint="Day"
              @input.native="$emit('input',$event.target.value)"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-0 py-0">
          <v-flex xs12 class="my-0 py-0">
            <label class="my-0 py-0 pl-2">{{f_field.title}} </label>
            {{artist[f_field.name]}}
          </v-flex> -->
      </v-flex>

      <v-flex v-else-if="this.field_type == 'bool'" px-3>
        <v-switch
          :value="`${f_artist[f_field.name]}`"
          :label="`${f_field.title}`"
          color="black"
        ></v-switch>
        <!-- v-model="`${f_field.name}`"  -->
      </v-flex>

      <v-flex v-else-if="this.field_type == 'radio'" px-3>
        <v-radio-group
          :label="`${f_field.title}`"
          :column="f_field.column ? f_field.column : false"
          :value="value_radio"
          :refs="f_field.name"
        >
          <v-radio
            v-for="s in f_field.selection"
            :label="s.name ? s.name : s"
            :value="s.value ? s.value : s"
            :key="s.id ? s.id : s"
            class="ml-3"
          ></v-radio>
        </v-radio-group>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'checkbox'" px-3>
        <v-flex>
          <h4 class="sub-headline mt-3 ml-3">{{ f_field.title }}</h4>
          <v-checkbox
            v-for="s in f_field.selection"
            hide-details
            :label="s.name ? s.name : s"
            :key="s.id ? s.id : s"
            class="left mr-3 ml-3"
            :refs="f_field.name"
            >{{ s.name ? s.name : s }}</v-checkbox
          >
        </v-flex>
      </v-flex>

      <v-flex v-else-if="this.field_type == 'toggle'" px-3 mb-2>
        <h4 class="body-2 mt-3 ml-1">{{ f_field.title }}</h4>
        <v-flex xs12 sm6 class="py-2">
          <v-btn-toggle v-model="toggle" @change="save">
            <v-btn
              small
              flat
              v-for="s in f_field.selection"
              :key="s.id ? s.value : s"
              class="px-2"
              :value="s.value"
            >
              <!-- <v-icon small>format_align_left</v-icon> -->
              <span> {{ s.name }} </span>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-flex>

      <v-layout v-else-if="f_field.etype === 'select'" px-3 mt-3 row wrap>
        <v-flex>
          <!-- :readonly="!isEditing" -->
          <!-- :value="value2" -->
          <!-- v-model="select_value" -->
          <v-select
            v-if="!f_field.just_text"
            @change="checkSubfields($event)"
            :value="value2"
            :items="selection_items"
            :label="`${f_field.title}`"
            item-text="name"
            item-value="id"
            :name="f_field.name"
            :ref="f_field.related_field"
            :append-outer-icon="f_field.addNew ? 'add' : ''"
            :preppend-icon="f_field.preicon"
            @click:append-outer="showAddForm"
          >
          </v-select>
          <div v-else>
            {{
              f_artist[f_field.name] ? f_artist[f_field.name].name : 'NOT FOUND'
            }}
          </div>

          <v-flex
            v-if="
              f_field.name == 'classification_new_id' &&
              this.select_value == 'film'
            "
          >
            <v-radio-group
              v-model="film.film_type"
              label="Select Film Type"
              row
            >
              <v-radio
                v-for="s in ['tape', 'film', 'digital born']"
                :label="s"
                :value="s"
                :key="s"
                class="ml-3"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex
            v-if="
              f_field.name == 'classification_new_id' &&
              this.select_value == 'inst'
            "
            class="xs12 mx-3"
          >
            <v-flex class="xs12 mx-3">
              <v-flex class="subheadline mt-4">Includes</v-flex>
              <v-checkbox
                v-for="s in [
                  'Objects',
                  'Sound',
                  'FilmVideoAV',
                  'Slide',
                  'Computer Program / Software / File',
                  'Performance',
                  'Light',
                  'Other',
                ]"
                v-model="instalation_includes"
                :key="s"
                :label="s"
                :value="s"
                hide-details
                xs12
                md6
                lg4
              ></v-checkbox>
            </v-flex>

            <v-flex
              v-if="this.instalation_includes.indexOf('FilmVideoAV') >= 0"
              class="xs12 mx-3"
            >
              <v-radio-group
                v-model="film.film_type"
                label="Select Film Type"
                row
              >
                <v-radio
                  v-for="s in ['tape', 'film', 'digital born']"
                  :label="s"
                  :value="s"
                  :key="s"
                  class="ml-3"
                ></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex
              v-if="this.instalation_includes.indexOf('Other') >= 0"
              class="xs12 mx-3"
            >
              <v-text-field
                v-model="film.film_type"
                class="ml-3"
                name="including_other"
                label="Other"
                row
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- <v-flex v-if="this.showingAddForm && f_field.addNew">
        <add-artist v-if="f_field.table=='artists'" itemToAdd="f_field"></add-artist>
      </v-flex> -->
      </v-layout>

      <v-flex v-else-if="f_field.etype === 'autocomplete'" mt-3 px-3>
        <v-autocomplete
          :value="value2"
          :items="this.selection_items"
          :label="`${f_field.title}`"
          item-text="name"
          item-value="id"
          :chips="f_field.chips"
          :multiple="f_field.multiple"
          :append-outer-icon="f_field.addNew ? 'add' : ''"
          @click:append-outer="showAddForm"
          clearable="true"
        >
          <!-- <v-icon
            @click="addArtistForm = true"
          >plus</v-icon> -->
        </v-autocomplete>
        <!-- <v-btn slot="activator" @click="addArtistForm = true" color="grey lighten-2" small icon>
          <v-icon small>add</v-icon>
        </v-btn> -->
        <!-- <v-flex v-if="f_field.name=='classification_new_id' && this.artist.classification_new_id=='film'">
          Show fvs sub-options here
        </v-flex> -->
      </v-flex>
    </div>
  </div>
</template>

<script>
// import EditFieldHeader from '@/components/artists/EditFieldHeader'
// import dynamic_fields from '@/data/dynamic_fields'
import fields from '@/data/full_user_fields'
// import axios from '@/utils/apiClient'
// import * as qs from "querystring";
import constants from '@/data/constants'
// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
  return (str + '').replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  )
}

export default {
  name: 'edit-field',
  // name: 'EditField',
  data() {
    return {
      toggle: 0,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      fields: fields,
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      field_value: '',
      show: true,
      model: {},
      menu2: '',
      date: '',
      // model: "artist_location"
      // this.f_field.show
    }
  },
  props: [
    'field',
    'artist',
    'placeholder',
    'label',
    'name',
    'value',
    'selection',
    'title',
    'fields_parent',
  ],
  mounted() {
    this.select_value = this.f_artist[this.f_field.name]
    this.toggle = this.f_artist[this.f_field.name]
  },
  methods: {
    checkSubfields(event) {
      // console.log(event)
      this.select_value = event
    },
    showAddForm() {
      this.showingAddForm = !this.showingAddForm
    },
    save() {
      // this.toggle
    },
    saveOrEdit() {
      this.isEditing = !this.isEditing
      this.$refs[this.f_field['name']].isFocused = true
      // console.log(this.f_field.name)
      // console.log(this.field_value)
      if (this.isEditing == false) {
        this.saved = true
        setTimeout(() => {
          let url = `${this.$globals.apiserver}/artists/${this.artist.id}.json`
          // axios.patch(url,{ 'field_name': this.f_field.name, 'field_value': this.field_value })
          //   .then((response) => {
          //     // console.log(response.data)
          //   })
          //   .catch((error) => { console.log(error) })
          this.saved = false
        }, 2000)
      }
    },
    // nefunguje tak ako chcem
    // format_date (date,format) {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find((l) => l.id === id).name
      } else {
        return 'Location not found. Probably deleted from CMS.'
      }
    },
  },
  computed: {
    hint() {
      var out = this.f_field.title
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '')
      return out
    },
    value2() {
      // console.log(parseInt(this.f_artist[this.f_field.related_field],10))
      return parseInt(this.f_artist[this.f_field.related_field], 10)
    },
    value_radio() {
      // console.log(this.f_artist[this.f_field.name])
      return this.f_artist[this.f_field.name]
    },
    // dynamic_field_list () {
    //   if (this.f_field.headline) {
    //     // console.log('test1')
    //     // console.log(dynamic_fields.dynamic_fields)
    //     // console.log(this.f_artist.classification)
    //     // console.log(this.fields)
    //     // console.log(dynamic_fields.dynamic_fields[this.f_artist.classification])
    //     // var a = dynamic_fields['dynamic_fields'][this.f_artist.classification]
    //     var c = []
    //     if (this.report) {
    //       var fields2 = this.fields_parent
    //     } else {
    //       var fields2 = this.fields['tabs'][this.$store.state.currentTab]['fields']
    //       // this.currentFields = this.fields.tabs[tab].fields

    //     }
    //     // console.log(fields2)
    //     // console.log('fields2')
    //     // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artist.classification])
    //     // console.log('test')
    //     // if (fields2.length > 0) {
    //       // var class_fields = fields2[this.f_artist.classification]
    //       c = fields2.filter(f => (f.dynamic && f.section === this.f_field.section))
    //       c = c.filter(f => (f.work_types && f.work_types.includes(this.artist.classification)))
    //       // console.log(c)
    //     // }
    //       // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artist.classification].filter(f => f.dynamic))
    //     return c
    //     // Object.values(a).filter(f => f.section === this.f_field.section)
    //     // console.log('test')
    //   } else {
    //     // console.log('not headline')
    //     return []
    //   }
    //   // return dynamic_fields[this.f_artist.ownership][this.f_field.title]
    // },
    // split_date () {
    // var moment = require('moment')
    // var date = this.f_artist[this.f_field.name]
    // var ndate = moment(this.f_artist[this.f_field.name],'YYYY')
    // var out = [ndate.year,ndate.month,ndate.day]
    // var out = [date.getFullYear,date.getMonth,date.getDay]
    // return ndate
    // },
    // field_value () {
    //   return this.f_artist[this.f_field.name]
    // },
    // is_field_value () {
    //   // console.log(typeof this.field_value)
    //   // console.log(this.field_value)
    //   if (this.field_value == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype
    },
    selection_items() {
      if (this.f_field.table) {
        if (this.f_field.table == 'contacts') {
          var contacts = Object.assign([], this.$store.state.contacts)
          if (this.f_field.column) {
            // console.log(this.f_field.column)
            // console.log(this.f_field.association)
            // console.log(contacts.filter(c => c[this.f_field.column] == this.f_field.association))
            return contacts.filter(
              (c) => c[this.f_field.column] == this.f_field.association
            )
          } else {
            return contacts
          }
        }
        if (this.f_field.table == 'artists') {
          var artists = Object.assign([], this.$store.state.artists)
          if (this.f_field.column) {
            return artists.filter(
              (c) => c[this.f_field.column] == c[this.f_field.association]
            )
          } else {
            return artists.sort(dynamicSort('name'))
          }
        }
        if (this.f_field.table == 'artist_locations') {
          // console.log(this.f_field.table)
          // console.log('this.f_field.table')
          var artist_locations = Object.assign(
            [],
            this.$store.getters.enabled_locations
          )
          if (this.f_field.column) {
            return artist_locations.filter(
              (c) => c[this.f_field.column] == c[this.f_field.association]
            )
          } else {
            return artist_locations.sort(dynamicSort('name'))
          }
        }
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection
      }
    },
    f_field() {
      var f = this.field
      f.model_string = this.field.model_string
        ? this.field.model_string
        : this.field.name
      f.column = this.field.column ? this.field.column : false
      // console.log(this.f_artist[this.field.name])
      f.value_string = this.field['model_string']
        ? this[this.field.model_string]
        : this.f_artist[this.field.name]
      return f
    },
    f_artist() {
      return this.artist
    },
    // value_calculated () {
    //   let output = ''
    //   switch (this.f_field.table) {
    //     case 'artists':
    //       if (this.f_field.name)
    //         output = nl2br(this.f_artist[this.field.name])
    //       else
    //         output = 'no artist name entered in cms'
    //       break
    //     case 'artist_locations':
    //       output = nl2br(this.f_artist[this.f_field.association][this.f_field.name])
    //       break
    //     case 'contacts':
    //       output = nl2br(this.f_artist[this.f_field.association][this.f_field.name])
    //       break
    //     default:
    //       output = nl2br(this.f_artist[this.f_field.name])
    //     if (output === undefined) {
    //       output = ''
    //     }
    //     if (output === null) {
    //       output = 0
    //     }
    //     if (this.f_field.suffix) {
    //       output += this.f_field.suffix
    //     }
    //       // console.log(this.f_artist)
    //   }
    //   return output
    // },
    // value_from_array () {
    //   let v = this.value_calculated
    //   return this.f_field.options[v]
    // },
    // value_calculated_empty () {
    //   let output = ''
    //   // let a = this.f_artist.id
    //   // console.log(this.f_artist)
    //   switch (this.f_field.table) {
    //     case 'artists':
    //       if (typeof this.f_artist !== 'undefined') {
    //         output = this.f_artist[this.f_field.name]
    //       } else {
    //         output = ''
    //       }
    //       break
    //     case 'artist_locations':
    //       if (typeof this.f_artist[this.f_field.association] !== 'undefined') {
    //         output = this.f_artist[this.f_field.association][this.f_field.name]
    //       } else {
    //         output = ''
    //       }
    //       break
    //     case 'contacts':
    //       if (typeof this.f_artist[this.f_field.association] !== 'undefined') {
    //         output = (this.f_artist[this.f_field.association][this.f_field.name])
    //       } else {
    //         output = ''
    //       }
    //       break
    //     default:
    //       output = this.f_artist[this.f_field.name]
    //   }
    //   let o=false
    //   if (output=='' || output==undefined || output==null) {
    //     o = false
    //   } else {
    //     o = true
    //   }
    //   return o
    // }
  },
  // components: {AddLocation,AddArtist,Costs,ViewArtworks,Upload,Location,Films,Audio,Light,Programme,InformationCarrier,Electrical,ReadingDevices,Links,NonElectrical,LoanConditions}
}
</script>

<style scoped>
li {
  list-style: none;
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/artists/EditField.vue